import { useTranslation } from "react-i18next";

/**
 * « Pilote » — the brand-tinted marker beside a round's status badge (Figma 325:23300).
 *
 * Dotless on purpose: the dot in `StatusBadge` means "lifecycle state", and a second dotted pill
 * beside it would read as a second status. This is an attribute of the round, not a stage it is in.
 *
 * It exists because US-E1-01's v2 amendment makes pilot/live a first-class setting — "the pilot is
 * a first-class appel, not a rehearsal, and its data must stay distinguishable in analytics, in the
 * handoff and in any later question about which method judged whom". Marking it in the list is the
 * cheapest place that promise is kept visible.
 */
export function PilotBadge() {
  const { t } = useTranslation("acquire");

  return (
    <span className="inline-flex shrink-0 items-center rounded-full bg-brand-50 px-2 py-0.5 text-xs-medium text-(--text-link)">
      {t("rounds.pilot")}
    </span>
  );
}
